
import state from "./moduleOwnersManagementState.js"
import mutations from "./moduleOwnersManagementMutations.js"
import getters from "./moduleOwnersManagementGetters.js"
import actions from './moduleOwnersManagementActions.js';
export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
